var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoCouvercle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2610_53",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 41,
    width: 81,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 41H15V69H96V41Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2610_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9924 48.6084H87.83C88.5108 48.6084 89.1258 48.9781 89.4553 49.5633L95.0558 59.6667C95.7587 60.9297 94.8582 62.5006 93.4306 62.5006H17.5699C16.1204 62.5006 15.2199 60.8989 15.9666 59.6051L21.8747 49.5017C22.2042 48.9165 22.8191 48.5776 23.478 48.5776H50.6464",
    stroke: "#1E1E1C",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5002 45.4358C57.7806 45.4358 59.6292 44.6635 59.6292 43.7108C59.6292 42.7581 57.7806 41.9858 55.5002 41.9858C53.2197 41.9858 51.3711 42.7581 51.3711 43.7108C51.3711 44.6635 53.2197 45.4358 55.5002 45.4358Z",
    stroke: "#1E1E1C",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3711 43.7104V53.2902C51.3711 54.2451 53.216 55.0153 55.5002 55.0153C57.7843 55.0153 59.6292 54.2451 59.6292 53.2902V43.7104",
    stroke: "#1E1E1C",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.873 65.4579V67.306C23.873 67.8297 24.4002 68.2301 25.0371 68.2301H85.9408C86.5778 68.2301 87.1049 67.8297 87.1049 67.306V65.2114",
    stroke: "#1E1E1C",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7246 60.5293V62.6239C15.7246 64.1333 16.9326 65.3962 18.4041 65.3962H92.5955C94.089 65.3962 95.275 64.1641 95.275 62.6239V60.8681",
    stroke: "#1E1E1C",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCouvercle);
export default __webpack_public_path__ + "static/media/pictoCouvercle.a1a93557e2699c2dbf129afe7d531cde.svg";
export { ForwardRef as ReactComponent };